import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import {SeasonTableDataModel, SeasonTablePromotionType} from '../season-table-data.model';

@Component({
  selector: 'tisa-season-table-entry',
  templateUrl: './season-table-entry.component.html',
  styleUrls: ['./season-table-entry.component.scss', '../season-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SeasonTableEntryComponent {
  @Input() entry: SeasonTableDataModel | undefined;

  @Input() liveMatchesTemplate: TemplateRef<any> | undefined = undefined;

  @Input() hasFormData = false;

  @Input() isClickable = false;

  @Output() readonly entryClicked = new EventEmitter<SeasonTableDataModel>();

  get entryPromotion(): string {
    const translationPrefix = 'standings.';

    switch (this.entry?.promotion) {
      case SeasonTablePromotionType.UCL:
        return translationPrefix + SeasonTablePromotionType.UCL;
      case SeasonTablePromotionType.UEL:
        return translationPrefix + SeasonTablePromotionType.UEL;
      case SeasonTablePromotionType.UECL:
        return translationPrefix + SeasonTablePromotionType.UECL;
      default:
        return '';
    }
  }

  get trophyImageUrl(): string {
    return this.entry?.promotion === SeasonTablePromotionType.UCL
      ? 'assets/img/lm-trophy.png'
      : '';
  }

  get entryClassByStatus(): string {
    switch (this.entry?.promotion) {
      case SeasonTablePromotionType.UCL:
        return '-first-position';
      case SeasonTablePromotionType.UECL:
        return '-ecl-position';
      case SeasonTablePromotionType.DROP:
        return '-drop-position';
      default:
        return '';
    }
  }
}
